// extracted by mini-css-extract-plugin
export var fadeIn = "_la-1";
export var modalContent = "_la-3";
export var overlay = "_la-0";
export var popoverContent = "_la-2";
export var results = "_la-5";
export var searchInputWrapper = "_la-4";